function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1258_6028)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.25391 3.46289H1.58203C1.29055 3.46289 1.05469 3.22703 1.05469 2.93555C1.05469 2.64407 1.29055 2.4082 1.58203 2.4082H4.25391C4.54539 2.4082 4.78125 2.64407 4.78125 2.93555C4.78125 3.22703 4.54539 3.46289 4.25391 3.46289Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.25391 7.68164H1.58203C1.29055 7.68164 1.05469 7.44578 1.05469 7.1543C1.05469 6.86282 1.29055 6.62695 1.58203 6.62695H4.25391C4.54539 6.62695 4.78125 6.86282 4.78125 7.1543C4.78125 7.44578 4.54539 7.68164 4.25391 7.68164Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.19922 5.57227H0.527344C0.235863 5.57227 0 5.3364 0 5.04492C0 4.75344 0.235863 4.51758 0.527344 4.51758H3.19922C3.4907 4.51758 3.72656 4.75344 3.72656 5.04492C3.72656 5.3364 3.4907 5.57227 3.19922 5.57227Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.84872 1.7947C9.42951 1.51609 8.87334 1.57121 8.51798 1.92654L5.61759 4.82693C5.20559 5.23893 5.20559 5.90633 5.61759 6.31833C6.02959 6.73032 6.69699 6.73032 7.10899 6.31833L9.39808 4.02923L11.0361 5.20918L13.2764 4.16775L9.84872 1.7947Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.72697 8.51822L0.871497 15.3737C0.459501 15.7857 0.459501 16.4531 0.871497 16.8651C1.28346 17.277 1.9509 17.2771 2.3629 16.8651L8.47266 10.7553L7.72697 8.51822Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.9453 7.15488H13.7461V5.04549C13.7461 4.6309 13.4953 4.23848 13.0944 4.07223C12.6909 3.90531 12.2366 4.00852 11.9454 4.30011L7.72697 8.51855C7.31497 8.93055 7.31497 9.59796 7.72697 10.01L10.1453 12.4283L7.19962 15.374C6.78763 15.786 6.78763 16.4534 7.19962 16.8654C7.61158 17.2774 8.27902 17.2774 8.69102 16.8654L12.3824 13.174C12.7944 12.762 12.7944 12.0946 12.3824 11.6826L9.96406 9.26425L11.6367 7.59158V8.20957C11.6367 8.792 12.109 9.26425 12.6914 9.26425H16.9453C17.5278 9.26425 18 8.792 18 8.20957C18 7.62713 17.5278 7.15488 16.9453 7.15488Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3281 3.99023C16.2019 3.99023 16.9102 3.28193 16.9102 2.4082C16.9102 1.53447 16.2019 0.826172 15.3281 0.826172C14.4544 0.826172 13.7461 1.53447 13.7461 2.4082C13.7461 3.28193 14.4544 3.99023 15.3281 3.99023Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1258_6028"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

const SvgSports = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSports, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sports.1c88170d.svg";
export { ForwardRef as ReactComponent };